<template>
  <MarketInsightsPageV2
    :tabs="tabs"
    :loading="loading"
    :articles="articles"
    :videos="videos"
    :events="events"
    :vimeo-source="vimeoSource"
    :video-ratio="videoRatio"
    :vimeo-video="vimeoVideo"
    :is-preview-video="isPreviewVideo"
    :market="NEW_TECHNOLOGY"
    @play-video="onPlayVideo"
  >
    <NuxtPage @play-video="onPlayVideo" />
  </MarketInsightsPageV2>
</template>

<script setup lang="ts">
import MarketInsightsPageV2 from '~/components/market/MarketInsightsPageV2.vue'
import {
  NEW_TECHNOLOGY,
  SILICON_ANODE,
  SODIUM_ION_BATTERIES,
  SOLID_STATE,
} from '~/constants/services/constants'
import type { TMarketSlug } from '~/src/types/markets'
import { getMarketInsightsTabs } from '~/src/utils/tabs'

const NEW_TECHNOLOGY_CATEGORIES: TMarketSlug[] = [
  SILICON_ANODE.slug,
  SODIUM_ION_BATTERIES.slug,
  SOLID_STATE.slug,
  NEW_TECHNOLOGY.slug,
]

const {
  videoRatio,
  vimeoSource,
  vimeoVideo,
  getMarketInsightsData,
  playVideo,
} = useMarketInsights()
const authStore = useAuthStore()
const { authenticated } = storeToRefs(authStore)
const { getSeoInfo } = useSeo()
const titlePage = `${NEW_TECHNOLOGY.name} Market Insights`
const seo = getSeoInfo({
  title: titlePage,
  description:
    "Dive into Benchmark's comprehensive resources on new technology. Explore videos, articles, and whitepapers focused on global supply chain dynamics.",
})

const isPreviewVideo = ref(false)
const tabs = getMarketInsightsTabs({ market: NEW_TECHNOLOGY.slug })

const onPlayVideo = async (video: any) => {
  isPreviewVideo.value = await playVideo(video, NEW_TECHNOLOGY.slug)
}

const { data, status } = useAsyncData(
  `${NEW_TECHNOLOGY.slug}-market-insights-hero`,
  async () => {
    return getMarketInsightsData(NEW_TECHNOLOGY.slug, NEW_TECHNOLOGY_CATEGORIES)
  },
  {
    watch: [authenticated],
    default() {
      return {
        articles: [],
        videos: [],
        events: [],
      }
    },
  },
)

const loading = computed(() => status.value !== 'success')
const events = computed(() => data.value?.events || [])
const articles = computed(() => data.value?.articles || [])
const videos = computed(() => data.value?.videos || [])

useHead({
  ...seo,
  title: `Benchmark Mineral Intelligence: ${titlePage}`,
})
</script>
